/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OpportunityCreate } from '../models/OpportunityCreate';
import type { OpportunityDetail } from '../models/OpportunityDetail';
import type { OpportunityNote } from '../models/OpportunityNote';
import type { OpportunityUpdate } from '../models/OpportunityUpdate';
import type { PaginatedOpportunityList } from '../models/PaginatedOpportunityList';
import type { PaginatedOpportunityNoteList } from '../models/PaginatedOpportunityNoteList';
import type { PatchedOpportunityNote } from '../models/PatchedOpportunityNote';
import type { PatchedOpportunityStatusUpdate } from '../models/PatchedOpportunityStatusUpdate';
import type { PatchedOpportunityUpdate } from '../models/PatchedOpportunityUpdate';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AssignmentsService {

    /**
     * @returns PaginatedOpportunityList
     * @throws ApiError
     */
    public static assignmentsOpportunitiesList({
        currentStatus,
        currentStatusCategory,
        facilityId,
        healthcareEntityId,
        limit,
        offset,
        ordering,
        search,
        showActive,
        showClosed,
    }: {
        /**
         * Short code representation of the status for viewing and reports
         */
        currentStatus?: string,
        /**
         * Short code representation of the status category for viewing and reports
         */
        currentStatusCategory?: string,
        facilityId?: string,
        healthcareEntityId?: string,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        /**
         * A search term.
         */
        search?: string,
        /**
         * Show Active
         */
        showActive?: boolean,
        /**
         * Show Closed
         */
        showClosed?: boolean,
    }): CancelablePromise<PaginatedOpportunityList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assignments/opportunities/',
            query: {
                'current_status': currentStatus,
                'current_status__category': currentStatusCategory,
                'facility_id': facilityId,
                'healthcare_entity_id': healthcareEntityId,
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
                'search': search,
                'show_active': showActive,
                'show_closed': showClosed,
            },
        });
    }

    /**
     * @returns OpportunityDetail
     * @throws ApiError
     */
    public static assignmentsOpportunitiesCreate({
        requestBody,
    }: {
        requestBody: OpportunityCreate,
    }): CancelablePromise<OpportunityDetail> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/assignments/opportunities/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns OpportunityNote
     * @throws ApiError
     */
    public static assignmentsOpportunitiesNoteUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Opportunity Note.
         */
        id: string,
        requestBody: OpportunityNote,
    }): CancelablePromise<OpportunityNote> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/assignments/opportunities-note/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns OpportunityNote
     * @throws ApiError
     */
    public static assignmentsOpportunitiesNotePartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Opportunity Note.
         */
        id: string,
        requestBody?: PatchedOpportunityNote,
    }): CancelablePromise<OpportunityNote> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/assignments/opportunities-note/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static assignmentsOpportunitiesNoteDestroy({
        id,
    }: {
        /**
         * A UUID string identifying this Opportunity Note.
         */
        id: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/assignments/opportunities-note/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns OpportunityDetail
     * @throws ApiError
     */
    public static assignmentsOpportunitiesRetrieve({
        id,
        provider,
    }: {
        /**
         * A UUID string identifying this Opportunity.
         */
        id: string,
        /**
         * Provider ID for rates
         */
        provider?: string,
    }): CancelablePromise<OpportunityDetail> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assignments/opportunities/{id}/',
            path: {
                'id': id,
            },
            query: {
                'provider': provider,
            },
        });
    }

    /**
     * @returns OpportunityDetail
     * @throws ApiError
     */
    public static assignmentsOpportunitiesUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Opportunity.
         */
        id: string,
        requestBody?: OpportunityUpdate,
    }): CancelablePromise<OpportunityDetail> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/assignments/opportunities/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns OpportunityUpdate
     * @throws ApiError
     */
    public static assignmentsOpportunitiesPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Opportunity.
         */
        id: string,
        requestBody?: PatchedOpportunityUpdate,
    }): CancelablePromise<OpportunityUpdate> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/assignments/opportunities/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static assignmentsOpportunitiesDestroy({
        id,
    }: {
        /**
         * A UUID string identifying this Opportunity.
         */
        id: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/assignments/opportunities/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns PaginatedOpportunityNoteList
     * @returns OpportunityNote
     * @throws ApiError
     */
    public static assignmentsOpportunitiesNotesList({
        id,
        currentStatus,
        currentStatusCategory,
        facilityId,
        healthcareEntityId,
        limit,
        offset,
        ordering,
        search,
        showActive,
        showClosed,
    }: {
        /**
         * A UUID string identifying this Opportunity.
         */
        id: string,
        /**
         * Short code representation of the status for viewing and reports
         */
        currentStatus?: string,
        /**
         * Short code representation of the status category for viewing and reports
         */
        currentStatusCategory?: string,
        facilityId?: string,
        healthcareEntityId?: string,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        /**
         * A search term.
         */
        search?: string,
        /**
         * Show Active
         */
        showActive?: boolean,
        /**
         * Show Closed
         */
        showClosed?: boolean,
    }): CancelablePromise<PaginatedOpportunityNoteList | OpportunityNote> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assignments/opportunities/{id}/notes/',
            path: {
                'id': id,
            },
            query: {
                'current_status': currentStatus,
                'current_status__category': currentStatusCategory,
                'facility_id': facilityId,
                'healthcare_entity_id': healthcareEntityId,
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
                'search': search,
                'show_active': showActive,
                'show_closed': showClosed,
            },
        });
    }

    /**
     * @returns PaginatedOpportunityNoteList
     * @returns OpportunityNote
     * @throws ApiError
     */
    public static assignmentsOpportunitiesNotesCreate({
        id,
        requestBody,
        currentStatus,
        currentStatusCategory,
        facilityId,
        healthcareEntityId,
        limit,
        offset,
        ordering,
        search,
        showActive,
        showClosed,
    }: {
        /**
         * A UUID string identifying this Opportunity.
         */
        id: string,
        requestBody: OpportunityNote,
        /**
         * Short code representation of the status for viewing and reports
         */
        currentStatus?: string,
        /**
         * Short code representation of the status category for viewing and reports
         */
        currentStatusCategory?: string,
        facilityId?: string,
        healthcareEntityId?: string,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        /**
         * A search term.
         */
        search?: string,
        /**
         * Show Active
         */
        showActive?: boolean,
        /**
         * Show Closed
         */
        showClosed?: boolean,
    }): CancelablePromise<PaginatedOpportunityNoteList | OpportunityNote> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/assignments/opportunities/{id}/notes/',
            path: {
                'id': id,
            },
            query: {
                'current_status': currentStatus,
                'current_status__category': currentStatusCategory,
                'facility_id': facilityId,
                'healthcare_entity_id': healthcareEntityId,
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
                'search': search,
                'show_active': showActive,
                'show_closed': showClosed,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns OpportunityDetail
     * @throws ApiError
     */
    public static assignmentsOpportunitiesStatusUpdatePartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Opportunity.
         */
        id: string,
        requestBody?: PatchedOpportunityStatusUpdate,
    }): CancelablePromise<OpportunityDetail> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/assignments/opportunities/{id}/status-update/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
